const cyrillicMap: Record<string, string> = {
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ё: "e",
  ж: "zh",
  з: "z",
  и: "i",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "sch",
  ъ: "",
  ы: "y",
  ь: "",
  э: "e",
  ю: "yu",
  я: "ya",
};

const transliterateCyrillic = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[а-яё]/g, (char) => cyrillicMap[char] ?? char);

/**
 * Derive a stable slug value from a display label.
 * e.g. "Communication Services" -> "communication-services"
 * e.g. "Обсуждаем примерную цену" -> "obsuzhdaem-primernuyu-tsenu"
 */
export const toSlug = (label: string): string =>
  transliterateCyrillic(label)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
